import { useEffect } from "react";
import { Form } from "antd";
import { useAtom } from "jotai";
import { frmPreguntasLimpiezaSeguridadAtom, puntajeTotalLimpiezaSeguridadAtom } from "../../BandejaEvaluacionStorage";

const usePreguntasLimpiezaSeguridad = () => {
	const [puntajeTotal, setPuntajeTotal] = useAtom(puntajeTotalLimpiezaSeguridadAtom);
	const [frmPreguntas, setFrmPreguntas] = useAtom(frmPreguntasLimpiezaSeguridadAtom);
	const [form] = Form.useForm();

	useEffect(() => {
		if (!frmPreguntas) {
			setFrmPreguntas(form);
		}
	}, []);

	return { frmPreguntas, puntajeTotal, setPuntajeTotal };
};

export default usePreguntasLimpiezaSeguridad;
